import * as React from 'react'
import { FC, useCallback } from 'react'
import { BulkActionsProps, BulkDelete } from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { bulkDeleteDraftLeads } from '@user/store/draftLeads'
import { toast } from '@sales-center/components'
import { useCheckBulkPermissions } from '@user/store/authorization/hooks'

export const DraftLeadBulkDelete: FC<BulkActionsProps> = ({ selectedRows }) => {
  const dispatch = useAppDispatch()

  const deleteCallback = useCallback(async () => {
    const ids = [...selectedRows.keys()].map((k) => Number(k))

    const result = await dispatch(bulkDeleteDraftLeads(ids))

    if (bulkDeleteDraftLeads.fulfilled.match(result)) {
      toast.success('Records deleted successfully')
      return true
    } else {
      if (result.payload) toast.error(result.payload.Message)
      return false
    }
  }, [dispatch, selectedRows])

  const { hasDeletePermission } = useCheckBulkPermissions('leads')
  return (
    <BulkDelete
      recordCount={selectedRows.size}
      saveCallback={deleteCallback}
      hasPermission={hasDeletePermission}
    />
  )
}
DraftLeadBulkDelete.displayName = 'DraftLeadBulkDelete'
